import { flexbox, type FlexboxProps } from '@material-ui/system'
import { SubTextStyled, TextStyled } from '@procurify/ui'
import { shade } from 'polished'
import styled, { css } from 'styled-components'

export const StatusCardNamedGridStyled = styled.div<
  { gridName: string; type?: string } & FlexboxProps
>`
  display: flex;

  align-items: center;

  grid-area: ${(props) => props.gridName};

  ${(props) => {
    if (
      props.gridName === 'leftHeaderLabel' ||
      props.gridName === 'leftHeaderValue' ||
      props.gridName === 'rightHeaderLabel' ||
      props.gridName === 'rightHeaderValue'
    )
      return css`
        border-bottom: 1px solid ${props.theme.colors.content.border};
        padding-bottom: 0.5em;
      `
  }}

  ${(props) => {
    if (props.type === 'label') {
      return css`
        ${TextStyled}, ${SubTextStyled} {
          color: ${shade(0.15, props.theme.colors.darkGrey)};
          text-transform: uppercase;
          font-size: ${props.theme.typography.pxToRem(11)};

          padding-right: 2em;
        }
      `
    }
  }}

  ${flexbox};
`
